mutation SetEarlyAccess($eventId: ID!, $attendeeIds: [ID!]!, $enabled: Boolean!) {
  setEarlyAccess(
    input: { eventId: $eventId, attendeeIds: $attendeeIds, enabled: $enabled }
  ) {
    updatedCount
  }
}
